<template>
  <div
    class="inner-menu"
    :class="{ 'inner-menu--nulled': list.lenght <= 0 }">
    <ul class="inner-menu__list">
      <li
        v-for="(item, index) of list"
        :class="{ 'inner-menu__list__item--active': $route.hash === item.hash }"
        :key="index">
        <router-link
          :to="{ name: parentRouteName, hash: item.hash }"
          @click.native="$emit('user-click', item.hash)">
          {{ item.title }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    parentRouteName: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
@import "../assets/mixins/breakpoints";
@import "../assets/mixins/typo";

  .inner-menu {
  position: sticky;
  background-color: #000;
  overflow: hidden;
  overflow-x: visible;
  z-index: 90;
  top: calc(100vh - 80px);
  border-bottom: 1px solid #4a4a4a;
}

.inner-menu--nulled {
  display: none;
}

.inner-menu__list{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  @media #{$medium_mq} {
    justify-content: center;
  }

  li {
    padding: 0 2.5rem;
  }

  a{
    @include size-16-pixel(#9b9b9b);
    line-height: 1.4rem;
    text-transform: uppercase;
    text-decoration: none;
    white-space: nowrap;
    font-weight: 100;
    transition: color 600ms cubic-bezier(0.23, 1, 0.32, 1);
    letter-spacing: .15rem;
    height: 80px;
    padding: 2rem 0;
    display: block;
  }

  a:hover, a.router-link-active{
    color: #EFEFF1;
  }

  a::before{
    position: absolute;
    left: -2px;
    bottom: 0;
    width: 0;
    content: "";
    height: 4px;
    background-color: #679196;
    transition: width 600ms cubic-bezier(0.23, 1, 0.32, 1);
  }

  a.router-link-active::before, a:hover::before{
    width: calc(100% + 4px);
  }

}

</style>
